import React from 'react';

const Schema = (props: { schema: Record<string, any> }) => {
	const { schema } = props;
	return (
		<script
			type="application/ld+json"
			dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
		/>
	);
};

export default Schema;
